module.exports = __webpack_public_path__ + "img/block.dd4260ce.svg";